import { CampaignLocator } from './types';
import { privateApiWithRouteLeavingCancelation } from '../ApiService/ApiServiceWithRouteLeavingCancelation';

const cancelableFetchCampaignType = (campaignId: string): Promise<CampaignLocator> =>
    privateApiWithRouteLeavingCancelation.getWithAbortControl<CampaignLocator>(`admin/campaign-locator/${campaignId}`);

export const CancelableCampaignLocatorGateway = {
    cancelableFetchCampaignType,
};
